<template>
  <div class="profile-groups-container">
    <div class="ui-block" :key="pageKey">
      <ul class="widget w-friend-pages-added friend-requests group-item-container">
        <li class="inline-items" v-for="group in groups" :key="group.id">
          <!-- A estrutura sera feita aqui -->
          <div class="group-info-container">
            <div class="avatar_and_info">
              <div class="avatar_group">
                <img
                  :src="getGroupImagePath(group)"
                  alt="author"
                  class="group-img"
                />
                <md-avatar class="avatar_group--badge md-avatar-icon md-primary">
                  <md-icon>groups</md-icon>
                </md-avatar>
              </div>
              <div class="info_group">
                <router-link
                  :to="`/s-app/group-page/${group.id}`"
                  class="group-name"
                  >{{ getGroupName(group) }}</router-link
                >
                <div class="type_and_member">
                  <span>{{ showPrivacy(group.privacy) }}</span>
                  <span>{{ membersCount }} members</span>
                </div>
              </div>
            </div>
            <div class="group_description">
              <span>{{ group.description }}</span>
            </div>
          </div>
          <!-- A estrutura termina aqui -->
          <span
            class="notification-icon"
            data-placement="top"
            :data-original-title="getToltipText(group)"
            @click="openModal(group)"
            style="cursor: pointer"
            data-cy="btnJoinGroupFavouriteGroups"
            :data-cy-groupname="getGroupName(group)"
          >
            <div
              class="spinner-border spinner-border-sm text-primary"
              role="status"
              v-if="requesting"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <button class="join-btn" :class="[
              {
                'hidden-button': groups.length > 0
              }
              ]">
              <span v-if="!verifyJoinedGroup[group.id] && !isMember(group)">
                {{ verifyIfUserSendRequest(group)}}
              </span>
            </button>
          </span>
        </li>
      </ul>
      <ModalNewJoinRequest
        @joinrequest="tryToJoinGroup"
        :name="groupName"
        :request="requesting"
        :result="joinResponse"
        :buttonTitle="setButtonTitle"
        @resetButton="resetModal"
      />

      <!-- .. end W-Friend-Pages-Added -->
    </div>
  </div>

</template>

<script>
import GroupHelperVue from "@/mixins/GroupHelper.vue";
import ModalNewJoinRequest from "@/components/molecules/ModalNewJoinRequest";
import groupPrivacy from "@/enum/group-privacy";
import UserHelperVue from "@/mixins/UserHelper.vue";

export default {
  name: "FavouriteGroups",
  mixins: [GroupHelperVue, UserHelperVue],
  components: { ModalNewJoinRequest },
  data() {
    return {
      requesting: false,
      groupName: "",
      joinResponse: "",
      setButtonTitle: "Send message",
      verifyJoinedGroup: {},
      pageKey: 0,
      groups: [],
      gPrivacy: groupPrivacy,
      membersCount: 0
    };
  },
  methods: {
    setJoinedGroups() {
      this.verifyJoinedGroup = {...this.getCurrentUserProfileMemberships};
      setTimeout(() => {
        $("[data-toggle='tooltip']").tooltip();
      }, 1000);
    },
    getUserGroups() {
      const groups = this.userGroups.slice().reverse().filter(group => {
        if(group.group.privacy === groupPrivacy.HIDDEN) {
          if(this.isThisMember(group.group)) {
            return group;
          }
        } else return group;
      });
      return groups.map(group => group.group);
    },
    isThisMember(theGroup) {
      return !!(this.myGroups.some((group) => group.groupId === theGroup.id));
    },
    update() {
      this.setJoinedGroups();
      this.pageKey += 1;
    },
    async tryToJoinGroup(e) {
      await this.fetchModerator({ group: { id: this.pickGroup.id } });
      this.requesting = true;
      const result = await this.newRequestToJoin({
        group: this.pickGroup,
        msg: e
      });
      await this.sendUserGroupMessageForModerator(this.getModerator, this.loggedUser, e, this.pickGroup.id);
      this.requesting = false;
      if (result.result === "You are already a member of this group") {
        this.joinResponse =
          "You already have a request to join this group. Please, wait for the moderator acceptance.";
      } else {
        this.joinResponse = result.result;
      }
      this.setButtonTitle = "Ok";
    },
    async openModal(g) {
      if (g !== undefined && g.id !== undefined) {
        this.groupName = g.name;
        this.pickGroup = g;
        if (g.privacy === groupPrivacy.PUBLIC) {
          this.joinGroup({
            groupId: this.pickGroup.id,
            groupName: this.groupName
          });
          this.verifyJoinedGroup[this.pickGroup.id] = true;
        } else {
          await this.fetchModerator({ group: g });
          $("#join-request").modal("show");
        }
      }
    },
    closeModal() {
      this.$refs.modal.closeModal();
    },
    resetModal() {
      this.setButtonTitle = "Send message";
      this.joinResponse = null;
      this.requesting = false;
    },
    isMember(theGroup) {
      return !!(this.getCurrentUserProfileMemberships[theGroup.id]);
    },
    getToltipText(group) {
      if (this.isMember(group)) {
        return "You are a member of this group";
      } else {
        return "Join this group";
      }
    },
    verifyIfUserSendRequest(group) {
      const userSendRequest = this.getMyJoinRequests.some(requests => requests.groupId === group.id)

      if(userSendRequest && this.verifyIfGroupIsPrivate(group)) {
        return "RESEND REQUEST"
      } else {
        return "JOIN"
      }

    },
    verifyIfGroupIsPrivate(group) {
      return group.privacy === groupPrivacy.PRIVATE
    },
    showPrivacy(privacy) {
      switch (privacy) {
        case 1:
          return "Public";
        case 2:
          return "Private";
        case 3:
          return "Hidden";
        default:
          return "";
      }
    },
  },
  mounted() {
    this.setJoinedGroups();
    this.groups = this.getUserGroups();
  },
  async created() {
   await this.fetchMyJoinRequests()

   this.myGroups.map(el => {
    return this.membersCount = el.membersCount
   })
  }
};
</script>
<style lang="scss" scoped>
  .group-info-container {
    width: 100%;
    padding: 10px;
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 20px;

    .avatar_and_info {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 5fr;
      column-gap: 15px;

      .avatar_group {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;

        .group-img {
          width: 32px;
          height: 32px !important;
        }

        .md-avatar {
          width: 24px;
          min-width: 24px;
          height: 24px;
        }

        .avatar_group--badge {
          position: absolute;
          top: 20px;
          left: 16px;
        }
      }

      .info_group {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .group-name{
          font-size: 18px;
          font-weight: 700;
          line-height: 16px;
          letter-spacing: 1.5px;
          color: black;
        }

        .type_and_member {
          width: 100%;
          display: flex;
          justify-content: space-between;

          span {
            font-size: 14px;
            font-weight: 500;
          }
        }
      }
    }

    .group_description {
    }
  }
  .profile-groups-container {
  }

  .ui-block {
    background-color: unset;
    border: unset;
  }

  .inline-items {
    background-color: white;
    border: 1px solid #e6ecf5;
    margin-bottom: 15px;
  }

  .inline-items:hover {
    background-color: white;
    border: 1px solid #c3c7ce;

  }

  .notification-event {
    padding-left: 20px !important;
  }

  .notification-event a {
    color: rgba(0, 0, 0, 0.696);
  }
  .join-btn {
    width: max-content;
    border: none;
    border-radius: 4px;
    background-color: #69287B ;
    color: white;
    padding: 10px 14px;
    font-weight: bold;
    letter-spacing: 2px;
  }
  .hidden-button {
    visibility: hidden
  }

  @media only screen and (min-width: 768px) {
    .group-info-container{
      .avatar_and_info {
        .avatar_group {
          .group-img {
            width: 52px;
            height: 52px !important;
          }

          .md-avatar {
            width: 28px;
            min-width: 28px;
            height: 28px;
          }

          .avatar_group--badge {
            top: 32px;
            left: 32px;
          }
        }
      }

      .group_description {
        width: 100%;
        display: flex;
        align-items: center;
      }
    }
  }

  @media only screen and (min-width: 1440px) {
    .group-info-container{
      .avatar_and_info {
        grid-template-columns: 1fr 11fr;
        .avatar_group {
          .group-img {
            width: 48px;
            height: 48px !important;
          }

          .md-avatar {
            width: 32px;
            min-width: 32px;
            height: 32px;
          }

          .avatar_group--badge {
            top: 26px;
            left: 28px;
          }
        }
      }

      .group_description {
        width: 100%;
        display: flex;
        align-items: center;
      }
    }
  }


</style>

<style lang="scss" scoped>
.color-icon {
  fill: chocolate;
}
.inline-items {
  overflow-wrap: break-word;
  display: flex !important;
  align-items: center;
}
.group-img {
  height: 34px !important;
  width: 34px;
  object-fit: cover !important;
}
</style>
